import axios from 'axios';

const list = (data) => axios.get('/pro/conf/list', data);
const save = (data) => axios.post('/pro/conf/save', data);

export default {
  list,
  save,
}


